export const DEFAULT_SOCIAL_IMAGE_URL =
  "https://imagedelivery.net/ZrdAKG8zF6UYv_PggC8zbw/44b4f039-54ab-4fdb-270d-6c290dc72700/public";

/**
 * SEO Researcher Brief 3 — Eddie-approved title / meta copy
 * (implement/publish, 2026-09-03). Visible H1s stay the short brand names:
 * homepage slogan, existing Services heading, and each location's short name.
 *
 * "Men's" names a service ("Men's Haircut"), never the salon: the shops cut
 * women's hair too. So the homepage title says "Hair Salon" (owner edit,
 * 2026-10-05) while service keywords keep "men's".
 */
export const HOME_PAGE_SEO = {
  title: "Eddie's Edition | Hair Salon in Los Angeles",
  description:
    "Men's haircuts, Korean perms, and down perms at Eddie's Edition — Pasadena, San Gabriel, Arts District, Mid-Wilshire. Book online.",
} as const;

export const SERVICES_PAGE_SEO = {
  title: "Men's Haircuts, Korean Perms & More | Eddie's Edition",
  description:
    "Men's haircut, Korean men's perm, down perm, color, and more. Prices vary by stylist — book at your LA location.",
} as const;

export type LocationPageSeo = {
  title: string;
  heading: string;
  description: string;
};

/**
 * Location-page SERP overrides, keyed by registry `pathId` only.
 * Locations absent from this map (sawtelle, edition-studio, …) keep the
 * existing `buildLocationBranding` template.
 */
export const LOCATION_PAGE_SEO: Record<string, LocationPageSeo> = {
  pasadena: {
    title: "Men's Haircut in Pasadena | Eddie's Edition",
    heading: "Pasadena",
    description:
      "Men's haircuts and Korean perms in Pasadena at 914 Union St. Easy online booking at Eddie's Edition.",
  },
  "san-gabriel": {
    title: "Men's Haircut in San Gabriel | Eddie's Edition",
    heading: "San Gabriel",
    description:
      "Men's haircuts and perms in San Gabriel at 123 N San Gabriel Blvd. Book Eddie's Edition online.",
  },
  dtla: {
    title: "Men's Haircut in Arts District / DTLA | Eddie's Edition",
    heading: "Arts District",
    description:
      "Men's haircuts at ROW DTLA / Arts District. Parking guidance + online booking at Eddie's Edition.",
  },
  "mid-wilshire": {
    title: "Men's Haircut Mid-Wilshire / Koreatown | Eddie's Edition",
    heading: "Mid Wilshire",
    description:
      "Men's haircuts and Korean perms near Koreatown at 4045 Wilshire Blvd. Book Eddie's Edition online.",
  },
};
